module.exports = __webpack_public_path__ + "static/media/birthday2023_gift.48cf64d4.png";